const state = {
  myLists: [],
  pinnedProductDetails: [],
};

export default state;